import * as F from "fp-ts/function";
import * as O from "fp-ts/Option";
import * as ORD from "fp-ts/Ord";
import * as RONEA from "fp-ts/ReadonlyNonEmptyArray";
import * as ROA from "fp-ts/ReadonlyArray";
import * as A from "fp-ts/Array";
import * as S from "fp-ts/string";
import * as R from "fp-ts/Record";
import { match } from "ts-pattern";
import {
  SanityShorexesSelectionConfirmedShorex,
  SanityShorexesSelection
} from "../use-sanity-shorex-content";

type GrouppedShorexes = {
  total: number;
  shorexes: readonly SanityShorexesSelectionConfirmedShorex[];
};
export type ShorexesGrouppedByCategory = [string, GrouppedShorexes];

export const shorexesGrouppedByCategory = (
  data: SanityShorexesSelection | undefined
): ShorexesGrouppedByCategory[] =>
  F.pipe(
    data?.confirmedShorexes || [],
    RONEA.fromArray,
    O.foldW(
      F.constant([]),
      F.flow(
        //keep new line
        groupByCategory,
        reduceNumberOfShorexesBasedOnNumberOfCategories
      )
    )
  );

const byCategory: ORD.Ord<SanityShorexesSelectionConfirmedShorex> = F.pipe(
  S.Ord,
  ORD.contramap((s) => s.shorex?.category || "")
);

export const groupByCategory = (
  a: RONEA.ReadonlyNonEmptyArray<SanityShorexesSelectionConfirmedShorex>
) =>
  F.pipe(
    a,
    RONEA.sort(byCategory),
    RONEA.groupBy((s) => s.shorex?.category || ""),
    R.toEntries
  );

//TODO: enable sorting by price when data is available
//const byPrice: ORD.Ord<SanityShorexesSelectionConfirmedShorex> = F.pipe(S.Ord, ORD.contramap((p) => p.shorex.price || 0))

const reduceNumberOfShorexesBasedOnNumberOfCategories = (
  grouppedShorexes: [
    string,
    RONEA.ReadonlyNonEmptyArray<SanityShorexesSelectionConfirmedShorex>
  ][]
): ShorexesGrouppedByCategory[] => {
  const numberOfCategories = grouppedShorexes.length;
  const maxItems = match(numberOfCategories)
    .with(0, () => 0)
    .with(1, () => 6)
    .with(2, () => 3)
    .otherwise(() => 2);

  return F.pipe(
    grouppedShorexes,
    A.map(([category, shorexes]) => [
      category,
      {
        total: shorexes.length,
        shorexes: F.pipe(
          shorexes,
          //RONEA.sort(byPrice),
          ROA.filterWithIndex((index, _) => index < maxItems) // Limit to 3 shorexes per category
        )
      }
    ])
  );
};
